import { useConfig } from "@/context/use-context";
import { useQuery } from "@tanstack/react-query";
import API from "./api";

interface AlertDetail {
	alert_id: string;
	alert_type: string;
	energy: "ELEC" | "GAS";
	value: number;
	unit: "kWh" | "EUR";
	support: string;
	creation_date: string;
	is_active: boolean;
}

interface AlertResponse {
	customer_id: string;
	pod: string;
	alerts_details: AlertDetail[];
}

export const fetchAlertData = async ({
	energy,
	BEARER_TOKEN,
	POD,
}: {
	energy: "ELEC" | "GAS";
	BEARER_TOKEN: string;
	POD: string;
}): Promise<AlertResponse> => {
	const response = await API.get(`/pods/${POD}/alerts`, {
		headers: {
			Authorization: `Bearer ${BEARER_TOKEN}`,
		},
		params: {
			energy,
		},
	});
	return response.data;
};

// React Query Hook
export const useAlertData = (params: {
	energy: "ELEC" | "GAS";
}) => {
	const config = useConfig();

	return useQuery({
		queryKey: ["alertData", params],
		queryFn: () =>
			fetchAlertData({
				...params,
				BEARER_TOKEN: config.bearerToken,
				POD: config.pod?.pod_id ?? "",
			}),
	});
};
